import { createFileRoute, redirect } from "@tanstack/react-router"
import { buildAccountUrl } from "@/app/auth"
export const Route = createFileRoute("/_authenticated/account/profile")({
    beforeLoad: () => {
        throw redirect({ href: buildAccountUrl("profile"), replace: true })
    },
})
